import React from "react";
import "./pdf.css";

import { useSelector } from "react-redux";
import PDFALLRoof from "./PDFAllRoof.jsx";
import PDFSingleRoof from "./PDFSingleRoof.jsx";

const Pdf = () => {
  const quantityInfo = useSelector((state) => state.quantity);
  const check = quantityInfo.allRoof;

  return (
    <>
      <div className="pdf-body">
        {check ? (
          <PDFALLRoof></PDFALLRoof>
        ) : (
          <PDFSingleRoof></PDFSingleRoof>
        )}
      </div>
    </>
  );
};

export default Pdf;
